import React, {useEffect, useState, useRef} from 'react';
import './_room-variable.scss';
import VButton from "../../../v-button/v-button";
import VStore from "../../../../store";
import {IRoomVariables} from "../../../../interfaces";

export default function RoomVariable() {

    const {
        currentFilter,
        screenshotMode,
        roomVariables,
        setCurrentFilter,
        setCurrentRoomVariables
    } = VStore();

    const [_currentRoomVariables, _setCurrentRoomVariables] = useState<IRoomVariables>(roomVariables);
    const timer = useRef<any>(null);

    function addRoomVariable(variable: 'bedroom' | 'bathroom' | 'garage') {
        let _variable = _currentRoomVariables[variable];
        _variable++;
        _setCurrentRoomVariables({..._currentRoomVariables, [variable]: _variable});
    }

    function minusRoomVariable(variable: 'bedroom' | 'bathroom' | 'garage') {
        let _variable = _currentRoomVariables[variable];
        if (_variable === 0) return;
        _variable--;
        _setCurrentRoomVariables({..._currentRoomVariables, [variable]: _variable});
    }

    function onMouseEnter() {
        clearTimeout(timer.current);
    }

    function onMouseLeave() {
        timer.current = setTimeout(() => {
            setCurrentFilter('');
        }, 1000);
    }

    useEffect(() => {
        if (currentFilter === 'room') {
            _setCurrentRoomVariables(roomVariables);
        }

    }, [currentFilter]);

    return (<div className={"room-variable" + (currentFilter === 'room' && !screenshotMode ? ' show' : '')} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
        <div className='room-variable__item'>
            <span>Bedrooms</span>
            <div className='d-flex justify-content-between align-items-center'>
                <VButton content='-'
                         width='1.5em'
                         height='1.5em'
                         onClick={() => minusRoomVariable('bedroom')}
                />
                <span>
                    {_currentRoomVariables.bedroom ? _currentRoomVariables.bedroom : 'Any'}
                </span>
                <VButton content='+'
                         width='1.5em'
                         height='1.5em'
                         onClick={() => addRoomVariable('bedroom')}
                />
            </div>
        </div>
        <div className='room-variable__item'>
            <span>Bathrooms</span>
            <div className='d-flex justify-content-between align-items-center'>
                <VButton content='-'
                         width='1.5em'
                         height='1.5em'
                         onClick={() => minusRoomVariable('bathroom')}
                />
                <span>
                    {_currentRoomVariables.bathroom ? _currentRoomVariables.bathroom : 'Any'}
                </span>
                <VButton content='+'
                         width='1.5em'
                         height='1.5em'
                         onClick={() => addRoomVariable('bathroom')}
                />
            </div>
        </div>
        <div className='room-variable__item'>
            <span>Garage</span>
            <div className='d-flex justify-content-between align-items-center'>
                <VButton content='-'
                         width='1.5em'
                         height='1.5em'
                         onClick={() => minusRoomVariable('garage')}
                />
                <span>
                    {_currentRoomVariables.garage ? _currentRoomVariables.garage + '+' : 'Any'}
                </span>
                <VButton content='+'
                         width='1.5em'
                         height='1.5em'
                         onClick={() => addRoomVariable('garage')}
                />
            </div>
        </div>
        <div className='d-flex justify-content-center'>
            <VButton content='Reset' className={'reset-btn'} onClick={() => _setCurrentRoomVariables(roomVariables)}></VButton>
            <VButton content='Save' className={'save-btn'} onClick={() => {
                setCurrentRoomVariables(_currentRoomVariables);
                setCurrentFilter('');
            }}></VButton>
        </div>
    </div>);
}
